import { gql } from '@apollo/client';

export const NOTIFICATION_FRAGMENT = gql`
  fragment NotificationFragment on UsersNotifications {
    body
    id
    read
    removed
    role_name
    user_id
    created_at
  }
`;
